import { render, staticRenderFns } from "./Technisches.vue?vue&type=template&id=35c83f03&scoped=true&"
import script from "./Technisches.vue?vue&type=script&lang=js&"
export * from "./Technisches.vue?vue&type=script&lang=js&"
import style0 from "./Technisches.vue?vue&type=style&index=0&id=35c83f03&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c83f03",
  null
  
)

export default component.exports